var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"special-request"},[_c('p',{staticClass:"special-request__text"},[_vm._v(_vm._s(_vm.data.spec_request_text))]),_c('p',{staticClass:"special-request__date"},[_vm._v(_vm._s(_vm.requestDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }